import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_312_4604)">
      <path
        d="M0.959867 10.267C1.114 11.7077 2.2727 12.8664 3.71266 13.0269C5.92445 13.2734 8.07554 13.2734 10.2873 13.0269C11.7273 12.8664 12.886 11.7077 13.0401 10.267C13.1539 9.20346 13.25 8.1116 13.25 6.99844C13.25 5.88529 13.1539 4.79343 13.0401 3.72992C12.886 2.28927 11.7273 1.13056 10.2873 0.970059C8.07554 0.723522 5.92445 0.723522 3.71266 0.970059C2.2727 1.13056 1.114 2.28927 0.959867 3.72992C0.846083 4.79343 0.75 5.88529 0.75 6.99844C0.75 8.1116 0.846084 9.20346 0.959867 10.267Z"
        fill="#070F21"
        stroke="white"
      />
      <path d="M7 4.5V9.5" stroke="white" strokeLinecap="round" />
      <path d="M4.5 7H9.5" stroke="white" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_312_4604">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const PlusButton = memo(ForwardRef);
export default PlusButton;
